<template>
  <v-container class="pa-0 ma-0 academics-page">
    <h1 class="show-title mb-10">{{ content.title }}</h1>

    <div class="academics-text">
      <p>
        Intellectual property (IP) refers to creations of the human mind that
        benefit from the legal protection of a property right. The main legal
        mechanisms for protecting IP are patents, trademarks and copyrights,
        covering a variety of creations, from literary and artistic works,
        symbols, names and images, to inventions and trade secrets.
      </p>
      <p>
        In the University context, IP can be considered as the outcome of
        research projects, collaborations and other activities.
      </p>
      <p>
        NOVA recently revised its Intellectual Property Policy that can be
        consulted
        <a href="#">here</a>. For information on how NOVA’s IP Policy daily
        operates and clarification of procedures and responsibilities associated
        with the management of IP at the University, please consult the
        <a href="#">Innovator’s Guide</a>.
      </p>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'IntellectualProperty',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
